import { Fragment, ReactNode } from "react";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";

export interface ModalProps {
  visible: boolean;
  children: ReactNode;
  onClose: () => void;
  align?: "top" | "center";
  mobileAlign?: "top" | "bottom";
}

export const Modal = ({
  visible,
  children,
  onClose,
  align = "center",
  mobileAlign = "bottom",
}: ModalProps) => (
  <Transition.Root show={visible} as={Fragment}>
    <Dialog
      as="div"
      static
      className="fixed inset-0 z-10 overflow-y-auto"
      open={visible}
      onClose={onClose}
    >
      <div
        className={classNames(
          "flex justify-center min-h-screen pb-20 text-center sm:p-0",
          {
            "items-end": mobileAlign === "bottom",
            "items-start": mobileAlign === "top",
            "sm:block": align === "center",
            "sm:items-start": align === "top",
          }
        )}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
        </Transition.Child>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enterTo="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div className="inline-block w-full px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white shadow-xl sm:rounded-lg sm:my-8 sm:align-middle sm:max-w-xl sm:p-6">
            {children}
          </div>
        </Transition.Child>
      </div>
    </Dialog>
  </Transition.Root>
);
